import { $ } from '@starberry/components';
import { Routes } from '../../routes';

export default {
  $: 'Box',
  props: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    bgImage: `url("${require('base/defaults/login-bg.jpg').default}")`,
    bgRepeat: 'no-repeat',
    bgSize: 'cover',
    bgPosition: 'center',
    minH: '100vh',
    py: 8,
    px: { sm: '6', lg: '8' },
    _after: {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
      zIndex: '1',
    },
  },
  subtitleLinkProps: {},
  children: ({ subtitleLinkProps }) => [
    {
      $: 'Box',
      props: {
        position: 'relative',
        maxW: { sm: 'xl' },
        mx: { sm: 'auto' },
        w: { sm: 'full' },
        zIndex: 5,
      },
      children: [
        {
          $: 'Box',
          props: {
            bg: 'white',
            py: { base: '4', sm: '20' },
            px: { base: '8', sm: '24' },
            shadow: 'base',
            rounded: { sm: 'lg' },
          },
          children: [
            {
              $: 'H5',
              children: $(
                'constants.translations.resetPassEmail.RESET_PASS_EMAIL_TITLE',
                'Forgot Password'
              ),
              props: {
                as: 'h2',
                pb: '2',
                textAlign: 'center',
              },
            },
            {
              $: 'Box',
              children: [
                {
                  $: 'Text',
                  children: $(
                    'constants.translations.resetPassEmail.RESET_PASS_SUBTITLE',
                    'Please enter the email address that you used when creating your account. An email will be sent to that address with instructions on how to reset your password.'
                  ),
                },
                {
                  $: 'Box',
                  props: {
                    textAlign: 'center',
                    mt: '2',
                  },
                  children: [
                    {
                      $: 'WrappedLink',
                      props: {
                        to: Routes.LoginPage,
                        ...subtitleLinkProps
                      },
                      children: $('constants.translations.signup.LOGIN_SIGNUP_LINK', 'Login'),
                    },
                    {
                      $: 'Text',
                      props: {
                        as: 'span',
                      },
                      children: ' or ',
                    },
                    {
                      $: 'WrappedLink',
                      props: {
                        to: Routes.SignUpPage,
                        ...subtitleLinkProps
                      },
                      children: $('constants.translations.login.SIGNUP_SIGNUP_LINK', 'Sign Up'),
                    },
                  ],
                },
              ],
              props: {
                fontSize: '0.875rem',
                textAlign: 'center',
                mb: '8',
              },
            },
            { $: 'ForgetPassForm' },
            { $: 'TermsForm', startText: 'By clicking “Reset Password” you agree to our ' },
          ],
        },
      ],
    },
  ],
};
